import { inject, Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";

@Injectable({
  providedIn: "root",
})
export class ModalService {
  dialog = inject(MatDialog);
  dialogRef: MatDialogRef<any> | null = null;

  openModal({ component, data, width, height }: any) {
    if (this.dialogRef) return;

    this.dialogRef = this.dialog.open(component, {
      width: width || "auto",
      height: height || "auto",
      data: data || {},
    });

    this.dialogRef?.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });

    return this.dialogRef;
  }

  closeModal() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
}
